import React from 'react';
import ToolItemLabel from '../ToolItemLabel';
import Widget from '../../IframeWidget/Widget';
import * as helper from '../../util/helper';
import {
    PopUp
    , Page
    , Nav
    , Content
    , Icon
    , DropDown
} from '@beisen/chaos-ui';

require('./ChartList.scss');

/*
    ChartList: 报表组件

*/

export default class ChartList extends React.Component {
    constructor(props) {
        super(props);
        this.handleTouchChart = this.handleTouchChart.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.switchReport = this.switchReport.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.state = {
            showPopUp: false
            , activeReportUrl: ''
            , reportTitle: ''
            , viewMode: 'view'
            , visible: false
            , activeItem: props.chartData.cmp_data.hasOwnProperty('activeItem') ? props.chartData.cmp_data.activeItem : ''
        };
    }

    componentWillReceiveProps(nextProps) {

    }

    handleBack() {
        this.setState({
            visible: false,
            activeItem: this.props.chartData.cmp_data.hasOwnProperty('activeItem') ? this.props.chartData.cmp_data.activeItem : ''
        });
        //helper.handleBack();
    }

    handleTouchChart() {
        this.props.touchToolItem && this.props.touchToolItem();
        let viewMode = 'report',
            activeUrl = '',
            reportTitle = '';
        if (!this.state.visible) {
            this.props.chartData.cmp_data.items.forEach(item => {
                if (item.value == this.props.chartData.cmp_data.activeItem) {
                    if (item['highchartaction']) {
                        viewMode = 'highcharts';
                    }
                    activeUrl = item['highchartaction'] ? item['highchartaction'] : item.action;
                    reportTitle = item.title;
                }
            });
            this.setState({
                viewMode: viewMode,
                activeReportUrl: activeUrl,
                reportTitle: reportTitle,
                visible: true,
                showPopUp: true
            }, () => {
                if (viewMode == 'highcharts') {
                    this.fetchDashBordData(activeUrl, this.props.tableData);
                }
            });
        } else {
            this.setState({
                activeReportUrl: '',
                reportTitle: '',
                visible: false
            });
        }

    }

    fetchDashBordData(activeUrl, tableData) {
        this.props.actions.fetchDashBordData(activeUrl, Object.assign({}, { search_data: this.props.searchData }, { table_data: tableData }), this.props.cmp_id);
    }

    afterClose() {
        this.setState({ showPopUp: false });
    }

    switchReport(item, e) {
        let viewMode = 'report';
        let activeUrl = item['highchartaction'] ? item['highchartaction'] : item.action;
        if (item['highchartaction']) {
            viewMode = 'highcharts';
        }
        this.setState({
            activeReportUrl: activeUrl,
            reportTitle: item.title,
            activeItem: item.value,
            viewMode: viewMode
        }, () => {
            helper.adjustHeaderConfig();
            if (viewMode == 'highcharts') {
                this.fetchDashBordData(activeUrl, {});
            }
        });
    }


    getDashbordCenter() {
        let { cmp_data } = this.props.chartData;
        let centerEl;
        if (cmp_data.items.length == 1) {
            centerEl = (<span role='center' cls='nav_center'> {
                cmp_data.items[0].title
            } </span>);
        } else {
            let reportSwitchView = {
                data: [],
                title: this.state.reportTitle
            };
            cmp_data.items.forEach(item => {
                reportSwitchView.data.push({
                    label: item.title,
                    ...item
                });
            });
            centerEl = (
                <DropDown role='center'
                    {...reportSwitchView}
                    registerEvent={'showDropDownForChart'}
                    onTouchTap={this.switchReport}
                    activeItem={this.state.activeItem}
                />
            );
        }
        return centerEl;
    }

    componentDidUpdate(preProps,preState) {
        if(this.state.visible) {
            if (helper.ifHidePopupNav()) {
                this.registCallback();
                this.setBoxHeader();
            }
        }else{
            //visible 由true 变成 false 表示关闭了报表的弹层
            if(preState.visible && helper.ifHidePopupNav()) {
                this.clearCallback();
                this.getPreHeaderConfig();
            }
        }
    }
    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        let { cmp_data } = this.props.chartData;
        let title = this.state.reportTitle;
        helper.generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'chartListBack',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            const right_item = [];
            config = setButton('right', right_item, config);
            if (cmp_data.items.length === 1) {
                title = cmp_data.items[0].title;
                config.titleItem = {
                    text: title,
                    icon: '',
                    callback: '',
                    control: false
                };
            } else {
                config.titleItem = {
                    text: title,
                    icon: '',
                    callback: 'showDropDownForChart',
                    control: true
                };
            }
            return config;
        });
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        helper.clearHeaderConfig();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['chartListBack'] = this.handleBack.bind(this);
        //showOrHideDropDownForChart  这个事件是在Dropdown组件中注册的
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['chartListBack'];
        delete window.globalEventManager['showDropDownForChart'];
    }


    renderWidget() {
        let navStyle = helper.ifHidePopupNav() ? { display: 'none' } : {};
        return (
            <Page cls='chart-page'>
                <Nav style={navStyle}>
                    <span role='left'>
                        <Icon icon='m-sys-backward' className='chart-back-icon' onTouchTap={this.handleBack} />
                    </span>
                    {this.getDashbordCenter()}
                </Nav>
                <Content>
                    <Widget width='100%'
                        cmp_id={this.props.chartData.cmp_id}
                        cmp_data={{ url: this.state.activeReportUrl }}
                        message={{
                            send: true
                            , content: this.props.searchData
                        }}
                        visible={this.state.visible}
                        chartData={this.props.chartData.chartData}
                        viewMode={this.state.viewMode}
                    />
                </Content>
            </Page>
        );
    }

    render() {
        const { translation } = this.props;
        return (
            <div className="tool-item-container" onTouchStart={this.handleTouchChart}>
                <ToolItemLabel label={translation.chartList}
                    type="fixed"
                    highlight={false}
                    iconName="m-sys-charts"
                />
                {this.state.showPopUp ?
                    <PopUp visible={this.state.visible}
                        animation="right-slide-fade"
                        maskAnimation="fade"
                        cls='charts-popup'
                        wrapClassName='charts-wrap'
                        maskStyle={{ zIndex: 2 }}
                        afterClose={this.afterClose}
                    >
                        {this.renderWidget()}
                    </PopUp>
                    : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ToolsBar/ChartList/ChartList.js